<template>
  <el-select
    size="mini"
    placeholder="Filtrar por servicio al cliente"
    v-bind:value="customerService"
    filterable
    clearable
    @change="handleChange"
    v-bind="$attrs"
    :disabled="
      !IsInRoles([roles.CoornidadorDeServicioAlCliente]) && editAgent == true
    "
  >
    <el-option
      v-for="(customerService, index) in customerServiceList"
      :key="index"
      :value="customerService.value"
      :label="customerService.label"
    >
      <el-avatar
        v-if="customerService.image"
        style="float: left"
        size="small"
        :src="customerService.image"
      ></el-avatar>
      <el-avatar
        v-else
        style="float: left"
        size="small"
        src="/static/images/avatar-2.jpg"
      ></el-avatar>
      <span style="padding-left: 3px; color: #8492a6; font-size: 12px"
        >{{ customerService.label.substring(0, 20) }}...</span
      >
    </el-option>
  </el-select>
</template>

<script>
export default {
  model: {
    prop: "customerService",
    event: "change"
  },
  props: {
    customerService: {
      type: Number,
      required: false,
      default: null
    },
    byUser: {
      type: Boolean,
      default: false
    },
    editAgent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    customerServiceList() {
      if (this.byUser) {
        return this.$store.getters[
          "customer_services/getCustomerServiceSelector"
        ];
      }

      return this.$store.getters[
        "customer_services/getCustomerServicesEmployee"
      ];
    }
  },
  methods: {
    getCustomerService(id) {
      return this.$store.getters["customer_services/getCustomerServiceById"](
        id
      );
    },
    handleChange(val) {
      this.$emit("update:customerService", val);
      this.$emit("change", val);

      const customerService = this.getCustomerService(val);
      this.$emit("selected-customer-service", customerService);
      this.$emit(
        "customerServiceSelected",
        this.customerServiceList.filter((csl) => csl.value === val)
      );
    }
  }
};
</script>
